<template>
    <v-card class="wz_cardLead">
      <div v-if="loading" class="wz_loadingChat text-xs-center" >
        <v-progress-circular  v-bind:size="70" v-bind:width="1" indeterminate class="primary--text "></v-progress-circular>
      </div>
      <div v-else-if="error">
        <v-alert type="warning" value="true">
          {{ $t('queryFailed') | cap }}
        </v-alert>
      </div>
      <div v-else class="ficheLeadVisiteur">
        <v-form class="formLeadVisiteur" v-on:change="changeForm" v-model="valid" ref="form" lazy-validation>
          <!-- OBJECTIF -->
          <v-layout row wrap v-if="visiteurLead.special_client !== '' && visiteurLead.special_client !== 'sisley' && visiteurLead.special_client !== 'hisense'">
            <v-flex xs12>
              <v-subheader>Objectif</v-subheader>
            </v-flex>
            <v-flex xs12>
              {{ visiteurLead.objectif_site }}<br>
              {{ visiteurLead.objectif_title }}<br>
              {{ visiteurLead.objectif_infos }}
            </v-flex>
          </v-layout>
          <!-- MOTIF COMMUN A TOUS-->
          <v-layout row wrap v-if="visiteurLead.special_client === '' || visiteurLead.special_client === 'hisense' || visiteurLead.special_client === 'orpi'">
            <v-flex xs12>
              <v-select
              :items="default_motif"
              v-model="visiteurLead.motif"
              :label="$tc('tags', 1, {count: ''})"
              menu-props="auto"
              v-on:change="changeForm"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- MOTIF CBRE -->
          <v-layout row wrap v-else-if="visiteurLead.special_client === 'cbre'">
            <v-flex xs12>
              <v-select
              v-bind:items="cbre_motif"
              v-model="visiteurLead.motif"
              :label="$tc('tags', 1, {count: ''})"
              menu-props="auto"
              v-on:change="changeForm"
              ></v-select>
            </v-flex>
          </v-layout> 
          <!-- MOTIF ORPI -->
          <!--<v-layout row wrap v-else-if="visiteurLead.special_client === 'orpi'">
            <v-flex xs12>
              <v-select
              v-bind:items="orpi_motif"
              v-model="visiteurLead.motif"
              label="Statut du chat"
              menu-props="auto"
              v-on:change="changeForm"
              ></v-select>
            </v-flex>
          </v-layout>-->
          <v-layout row wrap v-if="visiteurLead.special_client === 'orpi'">
            <v-flex xs12>
              <v-select
              v-bind:items="orpi_motif2"
              v-model="visiteurLead.orpi2"
              label="Préciser s'il s'agit d'un lead vendeur"
              menu-props="auto"
              v-on:change="changeForm"
              ></v-select>
            </v-flex>
          </v-layout>
         <!-- MOTIFS NUXE -->
          <div v-if="visiteurLead.special_client === 'nuxe'">
            <!-- MOTIF NUXE -->
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  @input="updateSubMotifNuxe"
                  v-bind:items="nuxe_motif"
                  v-model="visiteurLead.nuxe"
                  :label="$tc('tags', 1, {count: ''})"
                  menu-props="auto"
                  v-on:change="changeForm"
                ></v-select>
              </v-flex>
            </v-layout>
            <!-- MOTIF2 NUXE -->
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-bind:items="nuxe_motif_sub"
                v-model="visiteurLead.nuxe2"
                label="Sous Motif"
                menu-props="auto"
                v-on:change="changeForm"
                ></v-select>
              </v-flex>
            </v-layout>
          </div>
         <!-- MOTIF INOYA -->
          <div v-if="visiteurLead.special_client === 'inoya'">
          <v-layout row wrap >
            <v-flex xs12>
              <v-select
              @input="updateSubMotifInoya"
              v-bind:items="inoya_motif"
              v-model="visiteurLead.inoya"
              label="Motif"
              menu-props="auto"
              v-on:change="changeForm"
              ></v-select>
            </v-flex>
          </v-layout>
         <!-- MOTIF2 INOYA -->
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
              @input="updateSubSubMotifInoya"
              v-bind:items="inoya_motif2"
              v-model="visiteurLead.inoya2"
              label="Sous Motif"
              menu-props="auto"
              v-on:change="changeForm"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- MOTIF3 INOYA 
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
              v-bind:items="inoya_motif2bb"
              v-model="visiteurLead.inoya3"
              label="Sous-sous Motif"
              auto>
              </v-select>
            </v-flex>
          </v-layout>-->
          </div>
          <!-- CHAMPS LEAD -->
          <!-- CHAMPS CUSTOM -->
          <div v-for="(champ,y) in default_champs" :key="y">
            <div v-if="champ.value === 'gender'">
              <div>
                <v-flex xs12>
                  <wz-select-gender
                    :gender.sync="visiteurLead.gender"
                    :client="visiteurLead.special_client"
                  ></wz-select-gender>
                </v-flex>
              </div>
            </div>
            <div v-else-if="champ.value === 'comment'">
              <v-textarea
              :label="champ.text"
              v-model="visiteurLead.comment"
              v-on:keydown="changeForm()"
              >
              </v-textarea>
            </div>
            <div v-else-if="champ.value === 'fname'">
              <v-text-field
              :label="champ.text"
              v-model="visiteurLead.fname"
              v-on:keydown="changeForm()"
              >
              </v-text-field>
            </div>
            <div v-else-if="champ.value === 'lname'">
              <v-text-field
              :label="champ.text"
              v-model="visiteurLead.lname"
              v-on:keydown="changeForm()"
              >
              </v-text-field>
            </div>
            <div v-else-if="champ.value === 'email'">
              <v-text-field
              :label="champ.text"
              v-model="visiteurLead.email"
              :rules="[rules.required, rules.email]"
              v-on:keydown="changeForm()"
              >
              </v-text-field>
            </div>
            <div v-else-if="champ.value === 'tel'">
              <v-text-field
              :label="champ.text"
              v-model="visiteurLead.tel"
              v-on:keydown="changeForm()"
              >
              </v-text-field>
            </div> 
            <div v-else-if="champ.value === 'company'">
                <v-text-field
                :label="champ.text"
                v-model="visiteurLead.company"
                v-on:keydown="changeForm()"
                >
                </v-text-field>
            </div>
            <div v-else-if="champ.value === 'url'">
              <div v-if="visiteurLead.special_client != 'sisley'">
                <v-text-field
                :label="champ.text"
                v-model="visiteurLead.url"
                v-on:keydown="changeForm()"
                >
                </v-text-field>
              </div>
            </div>
            <div v-else>
              <v-text-field
              :label="champ.text"
              v-model="visiteurLead[champ.value]"
              v-on:keydown="changeForm()"
              >
              </v-text-field>
            </div>
          </div>
          <!-- AUTRES  -->
          <div v-if="visiteurLead.special_client !== ''">
            <div slot="header">{{ $t('otherinfo') }}</div>
              <!-- champs i -->
              <div v-for="(eezy,i) in champs_eezylead" :key="i" v-if="eezy.client === visiteurLead.special_client">
                <div v-for="(champ,j) in eezy.fields" :key="j">
                  <v-text-field v-if="champ.select !== '1'"
                    name="input-3-3"
                    :label="champ.text"
                    v-model="visiteurLead[champ.model]"
                    v-on:keydown="changeForm()"
                  ></v-text-field>
                  <v-select v-else
                    v-bind:items="champ.option"
                    :label="champ.text"
                    v-model="visiteurLead[champ.model]"
                    menu-props="auto"
                    v-on:keydown="changeForm()"
                    ></v-select>
                </div>
              </div>
          </div>
          <v-layout row>
            <v-spacer/>
            <v-btn @click="clear">{{ $t('cancel') }}</v-btn>
            <v-btn
              color="secondary"
              :loading="loadingSaveLead"
              :disabled="loadingSaveLead"
              @click="submit({dateSendLead: dateSendLead})"
            >{{ $t('save') }}</v-btn>
          </v-layout>
          <br />
          {{txtLead}} {{leadSendDate}}
          <br />
          <v-layout row>
            <v-btn
              v-if="visiteurLead.special_client === 'inoya'"
              color="primary"
              flat
              medium
              :loading="loadingLead"
              :disabled="loadingLead || leadSend"
              @click="inoyaEasiware('S1')"
            >
              <v-icon left>favorite_border</v-icon>
              Demande EASIWARE ouverte
            </v-btn>
            <v-btn
              v-if="visiteurLead.special_client === 'inoya'"
              color="primary"
              flat
              medium
              :loading="loadingLead2"
              :disabled="loadingLead2 || leadSend2"
              @click="inoyaEasiware('6')"
            >
              <v-icon left>favorite_border</v-icon>
              Demande EASIWARE cloturée
            </v-btn>
            <v-btn
              v-else-if="visiteurLead.special_client === 'nuxe'"
              color="primary"
              flat
              medium
              :loading="loadingLead"
              :disabled="loadingLead || leadSend"
              @click="sendlead"
            >
              <v-icon left>favorite_border</v-icon>
              EASIWARE
            </v-btn>

            <v-btn
              v-if="visiteurLead.special_client === 'sisley'"
              color="primary"
              flat
              medium
              :loading="loadingLead"
              :disabled="loadingLead || leadSend"
              @click="sisleyGetSelligent"
            >
              <v-icon left>favorite_border</v-icon>
              {{ $t('selligentget') }}
            </v-btn>

            <v-btn
              v-if="visiteurLead.special_client === 'hisense'"
              color="primary"
              flat
              medium
              :loading="loadingLead"
              :disabled="loadingLead || leadSend"
              @click="hisenseSAP"
            >
              <v-icon left>favorite_border</v-icon>
              Send to S.A.P.
            </v-btn>
            <!--<v-btn
              v-if="visiteurLead.special_client === 'sisley'"
              color="primary"
              flat
              small
              dark
              @click="sisleySelligent"
            >
              <v-icon left>favorite_border</v-icon>
              {{ $t('selligentpost') }}
            </v-btn>-->

            <v-btn
              v-else
              color="primary"
              flat
              medium
              :loading="loadingLead"
              :disabled="loadingLead || leadSend"
              @click="sendlead"
            >
              <v-icon left>mail_outline</v-icon>
              {{ $t('sendByEmail') }}
            </v-btn>

            <v-btn
              v-if="user.smsOn === '1'"
              color="primary"
              flat
              medium
              :loading="loadingSms"
              :disabled="loadingSms || smsSend"
              @click="sendSms"
            >
              <v-icon left>textsms</v-icon>
              {{ $t('sendBySms') }}
            </v-btn>
            <v-btn
              v-if="user.entSF === 'salesforce'"
              color="primary"
              flat
              medium
              :loading="loadingLeadSelesForce"
              :disabled="loadingLeadSelesForce"
              @click="salesforce"
            >
              <v-icon left>mail_outline</v-icon>
              Salesforce
            </v-btn>
            <v-btn
              v-if="user.entZD === 'zendesk'"
              color="primary"
              flat
              medium
              :loading="loadingLeadZendesk"
              :disabled="loadingLeadZendesk"
              @click="zendesk"
            >
              <v-icon left>mail_outline</v-icon>
              Zendesk
            </v-btn>
            <!--<v-btn primary flat small dark @click="ga" v-if="user.entGA === 'analytics'"><v-icon left>mail_outline</v-icon>Google Analytics</v-btn>-->
          </v-layout>
        </v-form>
      </div>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
/* import { MOTIFS_ORPI } from '../../constants' */
import _ from 'lodash'
export default {
  data () {
    return {
      loading: false,
      loadingLead: false,
      loadingSms: false,
      loadingSaveLead: false,
      dateSendLead: 0,
      leadSend: true,
      smsSend: true,
      loadingLead2: false,
      leadSend2: true,
      loadingLeadSelesForce: false,
      loadingLeadZendesk: false,
      infoStatus: true,
      txtLead: '',
      visiteurLead: {
        objectif: null,
        gender: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      valid: true,
      error: false,
      snackbar_lead: { text: '', show: false },
      theChat: '',
      default_champs: [
        { text: _.upperFirst(this.$t('gender')), value: 'gender' },
        { text: _.upperFirst(this.$t('lastName')), value: 'lname' },
        { text: _.upperFirst(this.$t('firstName')), value: 'fname' },
        { text: _.upperFirst(this.$t('comment')), value: 'comment' },
        { text: _.upperFirst(this.$t('email')), value: 'email' },
        { text: _.upperFirst(this.$t('phone')), value: 'tel' },
        { text: _.upperFirst(this.$t('company')), value: 'company' },
        { text: _.upperFirst(this.$t('url')), value: 'url' }
      ],
      default_motif: [
        { text: _.upperFirst(this.$t('support')), value: 'support' },
        { text: _.upperFirst(this.$t('lead')), value: 'lead' },
        {
          text: _.upperFirst(this.$tc('sales', 1, { count: '' })),
          value: 'sale'
        },
        { text: _.upperFirst(this.$t('estimate')), value: 'devis' },
        { text: _.upperFirst(this.$t('reservation')), value: 'resa' },
        { text: _.upperFirst(this.$t('contact')), value: 'contact' }
      ],
      orpi_motif2: [
        { text: 'Vendeur', value: 'Vendeur' }
      ],
      nuxe_motif: [
        { text: 'Informations Offres commerciales', value: '33' },
        { text: 'Informations produits', value: '2' },
        { text: 'Aide à la commande e commerce produits', value: '4' },
        { text: 'Mon compte Nuxe et moi', value: '7' },
        { text: 'Informations Programme de fidélité', value: '6' },
        { text: 'Réclamations Programme de fidélité', value: '29' },
        { text: 'Informations soins SPA', value: '172' },
        { text: "Demande d'échantillons", value: '9' },
        { text: 'Suivi de commande e commerce', value: '31' },
        { text: 'Diagnostic', value: '128' },
        { text: 'Aide à la commande SPA', value: '50' },
        { text: 'Informations Livraison', value: '32' },
        { text: 'Félicitations', value: '10' },
        { text: 'Réclamations - Qualité', value: '11' },
        { text: 'Réclamations - Cosmétovigilance', value: '13' },
        { text: 'Tests sur animaux', value: '28' },
        { text: 'Dons; Partenariat', value: '126' },
        { text: 'Autres', value: '8' }
      ],
      nuxe_motif_sub: [],

      nuxe_motif2a: [
        { text: 'Arrêt / reformulation', value: '20' },
        { text: 'Composition et ingredients', value: '21' },
        { text: 'Grossesse et allaitement', value: '24' }
      ],
      nuxe_motif31a: [
        { text: 'Réclamations E commerce', value: '36' }
      ],
      nuxe_motif6a: [
        { text: 'AJOUT DE PDV', value: '177' }
      ],
      nuxe_motif7a: [
        { text: 'MDP pas reçu', value: '54' }
      ],
      nuxe_motif8a: [
        { text: 'RH', value: '58' },
        { text: 'Service Communication FR', value: '59' },
        { text: 'Consumers/business', value: '66' },
        { text: 'Service Commercial (pharmacies)', value: '168' }
      ],
      nuxe_motif172a: [
        { text: 'Information livraison passeport', value: '148' },
        { text: 'Information / réservation Spa', value: '172' }
      ],
      inoya_motif: [
        { text: 'Informations sur la marque et les produits', value: '1' },
        { text: 'Informations Commandes', value: '2' },
        { text: 'Demande de échantillons', value: '3' },
        { text: 'Programme Fidélité', value: '4' },
        { text: 'Réclamations', value: '5' },
        { text: 'Demandes Marketing', value: '6' },
        { text: 'Demandes RH', value: '7' }
      ],
      inoya_motif2: [],
      inoya_motif2a: [
        { text: 'Ou trouver vos produits', value: '8' },
        { text: 'Protocole de soins', value: '10' },
        { text: 'Questions sur les prix', value: '11' },
        { text: 'Composition et Conservation des Produits', value: '12' },
        { text: 'Conseils sur des produits non vendus par INOYA', value: '13' }
      ],
      inoya_motif2b: [
        { text: 'Suivi de ma commande', value: '14' },
        { text: 'Difficulté à passer ma commande', value: '15' },
        { text: 'Livraison de ma commande', value: '16' },
        { text: 'Informations Paiement', value: '21' },
        { text: 'Codes Promo et Avantages particuliers', value: '25' },
        { text: 'Changement statut commande dans le Back Office', value: '39' }
      ],
      inoya_motif2bb: [],
      inoya_motif3: [
        { text: 'Délai de livraison', value: '18' },
        { text: 'Facture manquante pour la douane', value: '19' },
        { text: "Complément d'adresse", value: '20' }
      ],
      inoya_motif2c: [
        { text: 'Convertir Points Oya', value: '22' },
        { text: 'Envoi récompense carte de fidélité', value: '23' },
        { text: 'Demande de carte de fidélité', value: '24' },
        {
          text: 'Fidélité Mixte : Points OYA & Carte de fidélité',
          value: '26'
        },
        { text: 'Suggestions et Axes d amélioration', value: '27' }
      ],
      inoya_motif2d: [
        { text: 'Efficacité du protocole de soins', value: '28' },
        { text: 'Problèmes sur mon colis commandé', value: '33' },
        { text: 'Réclamations Aspect, texture et odeur', value: '29' },
        { text: 'Réaction allergique', value: '30' },
        { text: 'Demande de remboursement', value: '31' },
        { text: 'Désinscription Bases de données INOYA', value: '32' }
      ],
      inoya_motif2e: [
        { text: 'Partenariat Blog ou Réseaux Sociaux', value: '34' },
        { text: 'Demande de distribution commerciale', value: '35' },
        { text: 'Jeux concours', value: '36' },
        { text: 'Sollicitations Commerciales Extérieures', value: '37' },
        { text: 'Distributeurs INOYA', value: '38' }
      ],
      cbre_motif: [
        { text: 'Achat', value: '1' },
        { text: 'Location', value: '2' },
        { text: 'Bureau', value: '4' },
        { text: 'Entrepot', value: '6' },
        { text: 'Commerce', value: '7' },
        { text: 'Autre', value: '1' }
      ],
      /* orpi_motif: MOTIFS_ORPI, */
      champs_eezylead: [
        {
          client: 'preprod',
          fields: [
            { text: 'Département', model: 'departement' },
            { text: 'Ville', model: 'ville' },
            { text: 'Téléphone fixe', model: 'telf' },
            { text: 'Téléphone mobile', model: 'telm' },
            { text: 'Imposition', model: 'impos' },
            { text: 'Propriétaire', model: 'proprio' },
            { text: 'Profession-Poste occupé', model: 'job' },
            { text: 'Situation', model: 'situation' },
            { text: "Nb d'enfants", model: 'enfant' },
            { text: 'Crédit en cours', model: 'cTotal' },
            { text: 'Epargne', model: 'epargne' },
            { text: 'Date de recontact', model: 'dateRappel' },
            { text: 'Heure de recontact', model: 'horraireRappel' },
            { text: 'Revenu', model: 'revenu' },
            { text: 'Surface', model: 'surface' },
            { text: 'Destination', model: 'destination' },
            { text: 'Suite à donner', model: 'suite' },
            { text: 'Type', model: 'typebien' },
            { text: 'Numéro du programme*', model: 'programme' },
            { text: 'Habiter/Investir', model: 'acheter' },
            { text: "Code postal de l'internaute*", model: 'zip' },
            { text: 'Region du projet*', model: 'region' },
            { text: 'Budget', model: 'budget' },
            { text: 'Nb de pièces', model: 'nbpieces' },
            { text: 'Modèles', model: 'modele' },
            { text: 'Envie', model: 'envie' },
            { text: 'Immatriculation', model: 'immatriculation' },
            { text: 'Concession', model: 'concession' }
          ]
        },
        {
          client: 'aiguillon',
          fields: [
            { text: 'Département', model: 'departement' },
            { text: 'Programme', model: 'programme' }
          ]
        },
        {
          client: 'bnp',
          fields: [
            { text: 'Surface', model: 'surface' },
            { text: 'Code postal', model: 'zip' },
            { text: 'Type', model: 'typebien' },
            { text: 'Code postal', model: 'zip' },
            { text: 'Ville', model: 'ville' },
            { text: 'Téléphone fixe', model: 'zip' },
            { text: 'Téléphone mobile', model: 'telf' },
            { text: 'Imposition', model: 'impos' },
            { text: 'Propriétaire', model: 'proprio' },
            { text: 'Profession-Poste occupé', model: 'job' },
            { text: 'Situation', model: 'situation' },
            { text: "Nb d'enfants", model: 'enfant' },
            { text: 'Crédit en cours', model: 'cTotal' },
            { text: 'Epargne', model: 'epargne' },
            { text: 'Date de recontact', model: 'dateRappel' },
            { text: 'Heure de recontact', model: 'horraireRappel' },
            { text: 'Revenu', model: 'revenu' }
          ]
        },
        {
          client: 'frg',
          fields: [
            { text: 'Surface', model: 'surface' },
            { text: 'Destination', model: 'destination' },
            { text: 'Budget', model: 'budget' },
            { text: 'Nb de pièces', model: 'nbpieces' },
            { text: 'Programme', model: 'programme' },
            { text: 'Département', model: 'departement' },
            { text: 'Suite à donner', model: 'suite' },
            { text: 'Type', model: 'typebien' }
          ]
        },
        {
          client: 'sisley',
          fields: [
            { text: this.$t('leadCreationDate'), model: 'date_account' },
            { text: this.$t('leadBirthday'), model: 'date_birth' },
            { text: this.$t('leadLoyal'), model: 'status' },
            { text: this.$t('leadDateMember'), model: 'date_status' },
            { text: this.$t('leadNbPoints'), model: 'points_acquired' },
            { text: this.$t('leadNbPointsOngoin'), model: 'points_ongoing' },
            { text: this.$t('leadNbPointsCum'), model: 'points_cumyear' },
            {
              text: 'Optin email',
              model: 'optin_email',
              select: '1',
              option: [{ text: this.$t('yes'), value: 'Oui' },
                { text: this.$t('no'), value: 'Non' }]
            },
            { text: this.$t('leadDateFirstPurch'), model: 'date_first_purch' },
            { text: this.$t('leadDateLastPurch'), model: 'date_last_purch' },
            { text: this.$t('leadIdLastPurch'), model: 'last_trans' },
            { text: this.$t('leadAmountLastPurchTtc'), model: 'last_trans_ttc' },
            { text: this.$t('leadAmountLastPurchHt'), model: 'last_trans_ht' },
            { text: this.$t('leadDevise'), model: 'devise' },
            { text: this.$t('leadNbPointsLastPu'), model: 'points_last_trans' },
            {
              text: this.$t('leadPoints_and_pu'),
              model: 'achat_last_trans',
              select: '1',
              option: [{ text: this.$t('yes'), value: 'Oui' },
                { text: this.$t('no'), value: 'Non' }]
            }
          ]
        },
        {
          client: 'hisense',
          fields: [
            { text: _.upperFirst(this.$t('lastName')) + '*', model: 'lname' },
            { text: _.upperFirst(this.$t('firstName')) + '*', model: 'fname' },
            { text: _.upperFirst(this.$t('comment')), model: 'comment' },
            { text: _.upperFirst(this.$t('email')), model: 'email' },
            { text: _.upperFirst(this.$t('phone')) + '*', model: 'tel' },
            {
              text: 'Type de client*',
              model: 'user',
              select: '1',
              option:
              [
                 { text: 'Client Particulier', value: '10' },
                 { text: 'Revendeur', value: '20' },
                 { text: 'Revendeur pour Particulier', value: '30' },
                 { text: 'B2B', value: '40', selected: '1' }
              ]
            },
            { text: 'N° Client', model: 'client' },
            {
              text: 'Titre*',
              model: 'title',
              select: '1',
              option: [
                { text: 'Ms.', value: '0001' },
                { text: 'Mr.', value: '0002' },
                { text: 'Company', value: '0003' },
                { text: 'Mr. and Mrs.', value: '0004' }
              ]
            },
            {
              text: 'Utilisation Marketing',
              model: 'usage',
              select: '1',
              option: [{ text: 'Oui', value: 'Yes' },
                { text: 'Non', value: 'No' }]
            },
            {
              text: 'Type Contact Préféré',
              model: 'method',
              select: '1',
              option:
              [
                { text: 'Tel Protable', value: 'Z01' },
                { text: 'SMS', value: 'Z02' },
                { text: 'Tel Fixe', value: 'Z03' },
                { text: 'Tel Bureau', value: 'Z04' },
                { text: 'E-Mail', value: 'Z05' },
                { text: 'Tchat', value: 'Z06' },
                { text: 'Réseaux Sociaux', value: 'Z07' },
                { text: 'Whatsapp', value: 'Z08' }
              ]
            },
            { text: 'Adresse', model: 'address' },
            { text: 'Code postal*', model: 'zip' },
            { text: 'Ville*', model: 'city' },
            {
              text: 'Type de Bâtiment*',
              model: 'building',
              select: '1',
              option: [
                { text: 'Maison', value: '01' },
                { text: 'Appartement', value: '02' },
                { text: 'Magasin', value: '03' },
                { text: 'Société', value: '04' },
                { text: 'Hôtel', value: '05' },
                { text: 'Hôpital', value: '06' },
                { text: 'Ecole', value: '07' },
                { text: 'Lieu Publique', value: '08' },
                { text: 'Stade', value: '09' },
                { text: 'Base militaire', value: '10' },
                { text: 'Installation Haute Sécurité', value: '11' },
                { text: 'Autres', value: '12' }
              ]
            },
            {
              text: 'Pays*',
              model: 'country',
              select: '1',
              option: [
                { text: 'France', value: 'FR' },
                { text: 'Andorran', value: 'AD' },
                { text: 'Utd.Arab Emir.', value: 'AE' },
                { text: 'Afghanistan', value: 'AF' },
                { text: 'Antigua/Barbuda', value: 'AG' },
                { text: 'Anguilla', value: 'AI' },
                { text: 'Albania ', value: 'AL' },
                { text: 'Armenia ', value: 'AM' },
                { text: 'Dutch Antilles', value: 'AN' },
                { text: 'Angola', value: 'AO' },
                { text: 'Antarctica ', value: 'AQ' },
                { text: 'Argentina', value: 'AR' },
                { text: 'Samoa, America', value: 'AS' },
                { text: 'Austria ', value: 'AT' },
                { text: 'Australia', value: 'AU' },
                { text: 'Aruba', value: 'AW' },
                { text: 'Azerbaijan ', value: 'AZ' },
                { text: 'Bosnia-Herz.', value: 'BA' },
                { text: 'Barbados', value: 'BB' },
                { text: 'Bangladesh ', value: 'BD' },
                { text: 'Belgium ', value: 'BE' },
                { text: 'Burkina Faso', value: 'BF' },
                { text: 'Bulgaria', value: 'BG' },
                { text: 'Bahrain ', value: 'BH' },
                { text: 'Burundi ', value: 'BI' },
                { text: 'Benin', value: 'BJ' },
                { text: 'Blue ', value: 'BL' },
                { text: 'Bermuda ', value: 'BM' },
                { text: 'Brunei Daruss.', value: 'BN' },
                { text: 'Bolivia ', value: 'BO' },
                { text: 'Brazil', value: 'BR' },
                { text: 'Bahamas ', value: 'BS' },
                { text: 'Bhutan', value: 'BT' },
                { text: 'Bouvet Islands', value: 'BV' },
                { text: 'Botswana', value: 'BW' },
                { text: 'Belarus ', value: 'BY' },
                { text: 'Belize', value: 'BZ' },
                { text: 'Canada', value: 'CA' },
                { text: 'Coconut Islands', value: 'CC' },
                { text: 'Dem. Rep. Congo', value: 'CD' },
                { text: 'CAR', value: 'CF' },
                { text: 'Rep.of Congo', value: 'CG' },
                { text: 'Switzerland', value: 'CH' },
                { text: 'Cote dIvoire ', value: 'CI' },
                { text: 'Cook Islands', value: 'CK' },
                { text: 'Chile', value: 'CL' },
                { text: 'Cameroon', value: 'CM' },
                { text: 'China', value: 'CN' },
                { text: 'Colombia', value: 'CO' },
                { text: 'Costa Rica ', value: 'CR' },
                { text: 'Serbia/Monten.', value: 'CS' },
                { text: 'Cuba ', value: 'CU' },
                { text: 'Cape Verde ', value: 'CV' },
                { text: 'Christmas Islnd', value: 'CX' },
                { text: 'Cyprus', value: 'CY' },
                { text: 'Czech Republic', value: 'CZ' },
                { text: 'Germany ', value: 'DE' },
                { text: 'Djibouti', value: 'DJ' },
                { text: 'Denmark ', value: 'DK' },
                { text: 'Dominica', value: 'DM' },
                { text: 'Dominican Rep.', value: 'DO' },
                { text: 'Algeria ', value: 'DZ' },
                { text: 'Ecuador ', value: 'EC' },
                { text: 'Estonia ', value: 'EE' },
                { text: 'Egypt', value: 'EG' },
                { text: 'West Sahara', value: 'EH' },
                { text: 'Eritrea ', value: 'ER' },
                { text: 'Spain', value: 'ES' },
                { text: 'Ethiopia', value: 'ET' },
                { text: 'European Union', value: 'EU' },
                { text: 'Finland ', value: 'FI' },
                { text: 'Fiji ', value: 'FJ' },
                { text: 'Falkland Islnds', value: 'FK' },
                { text: 'Micronesia ', value: 'FM' },
                { text: 'Faroe Islands ', value: 'FO' },
                { text: 'France', value: 'FR' },
                { text: 'Gabon', value: 'GA' },
                { text: 'United Kingdom', value: 'GB' },
                { text: 'Grenada ', value: 'GD' },
                { text: 'Georgia ', value: 'GE' },
                { text: 'French Guayana', value: 'GF' },
                { text: 'Ghana', value: 'GH' },
                { text: 'Gibraltar', value: 'GI' },
                { text: 'Greenland', value: 'GL' },
                { text: 'Gambia', value: 'GM' },
                { text: 'Guinea', value: 'GN' },
                { text: 'Guadeloupe ', value: 'GP' },
                { text: 'Equatorial Guin', value: 'GQ' },
                { text: 'Greece', value: 'GR' },
                { text: 'S. Sandwich Ins', value: 'GS' },
                { text: 'Guatemala', value: 'GT' },
                { text: 'Guam ', value: 'GU' },
                { text: 'Guinea-Bissau ', value: 'GW' },
                { text: 'Guyana', value: 'GY' },
                { text: 'Hong Kong', value: 'HK' },
                { text: 'Heard/McDon.Isl', value: 'HM' },
                { text: 'Honduras', value: 'HN' },
                { text: 'Croatia ', value: 'HR' },
                { text: 'Haiti', value: 'HT' },
                { text: 'Hungary ', value: 'HU' },
                { text: 'Indonesia', value: 'ID' },
                { text: 'Ireland ', value: 'IE' },
                { text: 'Israel', value: 'IL' },
                { text: 'India', value: 'IN' },
                { text: 'Brit.Ind.Oc.Ter', value: 'IO' },
                { text: 'Iraq ', value: 'IQ' },
                { text: 'Iran ', value: 'IR' },
                { text: 'Iceland ', value: 'IS' },
                { text: 'Italy', value: 'IT' },
                { text: 'Jamaica ', value: 'JM' },
                { text: 'Jordan', value: 'JO' },
                { text: 'Japan', value: 'JP' },
                { text: 'Kenya', value: 'KE' },
                { text: 'Kyrgyzstan ', value: 'KG' },
                { text: 'Cambodia', value: 'KH' },
                { text: 'Kiribati', value: 'KI' },
                { text: 'Comoros ', value: 'KM' },
                { text: 'St Kitts&Nevis', value: 'KN' },
                { text: 'North Korea', value: 'KP' },
                { text: 'South Korea', value: 'KR' },
                { text: 'Kuwait', value: 'KW' },
                { text: 'Cayman Islands', value: 'KY' },
                { text: 'Kazakhstan ', value: 'KZ' },
                { text: 'Laos ', value: 'LA' },
                { text: 'Lebanon ', value: 'LB' },
                { text: 'St. Lucia', value: 'LC' },
                { text: 'Liechtenstein ', value: 'LI' },
                { text: 'Sri Lanka', value: 'LK' },
                { text: 'Liberia ', value: 'LR' },
                { text: 'Lesotho ', value: 'LS' },
                { text: 'Lithuania', value: 'LT' },
                { text: 'Luxembourg ', value: 'LU' },
                { text: 'Latvia', value: 'LV' },
                { text: 'Libya', value: 'LY' },
                { text: 'Morocco ', value: 'MA' },
                { text: 'Monaco', value: 'MC' },
                { text: 'Moldova ', value: 'MD' },
                { text: 'Montenegro ', value: 'ME' },
                { text: 'Madagascar ', value: 'MG' },
                { text: 'Marshall Islnds', value: 'MH' },
                { text: 'Macedonia', value: 'MK' },
                { text: 'Mali ', value: 'ML' },
                { text: 'Burma', value: 'MM' },
                { text: 'Mongolia', value: 'MN' },
                { text: 'Macau', value: 'MO' },
                { text: 'N.Mariana Islnd', value: 'MP' },
                { text: 'Martinique ', value: 'MQ' },
                { text: 'Mauretania ', value: 'MR' },
                { text: 'Montserrat ', value: 'MS' },
                { text: 'Malta', value: 'MT' },
                { text: 'Mauritius', value: 'MU' },
                { text: 'Maldives', value: 'MV' },
                { text: 'Malawi', value: 'MW' },
                { text: 'Mexico', value: 'MX' },
                { text: 'Malaysia', value: 'MY' },
                { text: 'Mozambique ', value: 'MZ' },
                { text: 'Namibia ', value: 'NA' },
                { text: 'New Caledonia ', value: 'NC' },
                { text: 'Niger', value: 'NE' },
                { text: 'Norfolk Islands', value: 'NF' },
                { text: 'Nigeria ', value: 'NG' },
                { text: 'Nicaragua', value: 'NI' },
                { text: 'Netherlands', value: 'NL' },
                { text: 'Norway', value: 'NO' },
                { text: 'Nepal', value: 'NP' },
                { text: 'Nauru', value: 'NR' },
                { text: 'NATO ', value: 'NT' },
                { text: 'Niue ', value: 'NU' },
                { text: 'New Zealand', value: 'NZ' },
                { text: 'Oman ', value: 'OM' },
                { text: 'Orange', value: 'OR' },
                { text: 'Panama', value: 'PA' },
                { text: 'Peru ', value: 'PE' },
                { text: 'Frenc.Polynesia', value: 'PF' },
                { text: 'Pap. New Guinea', value: 'PG' },
                { text: 'Philippines', value: 'PH' },
                { text: 'Pakistan', value: 'PK' },
                { text: 'Poland', value: 'PL' },
                { text: 'St.Pier,Miquel.', value: 'PM' },
                { text: 'Pitcairn Islnds', value: 'PN' },
                { text: 'Puerto Rico', value: 'PR' },
                { text: 'Palestine', value: 'PS' },
                { text: 'Portugal', value: 'PT' },
                { text: 'Palau', value: 'PW' },
                { text: 'Paraguay', value: 'PY' },
                { text: 'Qatar', value: 'QA' },
                { text: 'Reunion ', value: 'RE' },
                { text: 'Romania ', value: 'RO' },
                { text: 'Russian Fed.', value: 'RU' },
                { text: 'Rwanda', value: 'RW' },
                { text: 'Saudi Arabia', value: 'SA' },
                { text: 'Solomon Islands', value: 'SB' },
                { text: 'Seychelles ', value: 'SC' },
                { text: 'Sudan', value: 'SD' },
                { text: 'Sweden', value: 'SE' },
                { text: 'Singapore', value: 'SG' },
                { text: 'Saint Helena', value: 'SH' },
                { text: 'Slovenia', value: 'SI' },
                { text: 'Svalbard', value: 'SJ' },
                { text: 'Slovakia', value: 'SK' },
                { text: 'Sierra Leone', value: 'SL' }
              ]
            },
            {
              text: 'Département',
              model: 'province',
              select: '1',
              option: [
                { text: 'Ain', value: '01' },
                { text: 'Aisne', value: '02' },
                { text: 'Allier ', value: '03' },
                { text: 'Alpes (Hte-Provence) ', value: '04' },
                { text: 'Hautes-Alpes ', value: '05' },
                { text: 'Alpes-Maritimes', value: '06' },
                { text: 'Ardèche', value: '07' },
                { text: 'Ardennes ', value: '08' },
                { text: 'Ariège ', value: '09' },
                { text: 'Aube ', value: '10' },
                { text: 'Aude ', value: '11' },
                { text: 'Aveyron', value: '12' },
                { text: 'Bouches-du-Rhône ', value: '13' },
                { text: 'Calvados ', value: '14' },
                { text: 'Cantal ', value: '15' },
                { text: 'Charente ', value: '16' },
                { text: 'Charente-Maritime', value: '17' },
                { text: 'Cher ', value: '18' },
                { text: 'Corrèze', value: '19' },
                { text: 'Côte-d Or', value: '21' },
                { text: 'Côtes-d Armor', value: '22' },
                { text: 'Creuse ', value: '23' },
                { text: 'Dordogne ', value: '24' },
                { text: 'Doubs', value: '25' },
                { text: 'Drôme', value: '26' },
                { text: 'Eure ', value: '27' },
                { text: 'Eure-et-Loir ', value: '28' },
                { text: 'Finistère', value: '29' },
                { text: 'Corse-du-Sud ', value: '2A' },
                { text: 'Corse-du-Nord', value: '2B' },
                { text: 'Gard ', value: '30' },
                { text: 'Haute-Garonne', value: '31' },
                { text: 'Gers ', value: '32' },
                { text: 'Gironde', value: '33' },
                { text: 'Hérault', value: '34' },
                { text: 'Ille-et-Vilaine', value: '35' },
                { text: 'Indre', value: '36' },
                { text: 'Indre-et-Loire ', value: '37' },
                { text: 'Isère', value: '38' },
                { text: 'Jura ', value: '39' },
                { text: 'Landes ', value: '40' },
                { text: 'Loir-et-Cher ', value: '41' },
                { text: 'Loire', value: '42' },
                { text: 'Haute-Loire', value: '43' },
                { text: 'Loire-Atlantique ', value: '44' },
                { text: 'Loiret ', value: '45' },
                { text: 'Lot', value: '46' },
                { text: 'Lot-et-Garonne ', value: '47' },
                { text: 'Lozère ', value: '48' },
                { text: 'Maine-et-Loire ', value: '49' },
                { text: 'Manche ', value: '50' },
                { text: 'Marne', value: '51' },
                { text: 'Haute-Marne', value: '52' },
                { text: 'Mayenne', value: '53' },
                { text: 'Meurthe-et-Moselle ', value: '54' },
                { text: 'Meuse', value: '55' },
                { text: 'Morbihan ', value: '56' },
                { text: 'Moselle', value: '57' },
                { text: 'Nièvre ', value: '58' },
                { text: 'Nord ', value: '59' },
                { text: 'Oise ', value: '60' },
                { text: 'Orne ', value: '61' },
                { text: 'Pas-de-Calais', value: '62' },
                { text: 'Puy-de-Dôme', value: '63' },
                { text: 'Pyrénées-Atlantiques ', value: '64' },
                { text: 'Hautes-Pyrénées', value: '65' },
                { text: 'Pyrénées-Orientales', value: '66' },
                { text: 'Bas-Rhin ', value: '67' },
                { text: 'Haut-Rhin', value: '68' },
                { text: 'Rhône', value: '69' },
                { text: 'Haute-Saône', value: '70' },
                { text: 'Saône-et-Loire ', value: '71' },
                { text: 'Sarthe ', value: '72' },
                { text: 'Savoie ', value: '73' },
                { text: 'Haute-Savoie ', value: '74' },
                { text: 'Paris', value: '75' },
                { text: 'Seine-Maritime ', value: '76' },
                { text: 'Seine-et-Marne ', value: '77' },
                { text: 'Yvelines ', value: '78' },
                { text: 'Deux-Sèvres', value: '79' },
                { text: 'Somme', value: '80' },
                { text: 'Tarn ', value: '81' },
                { text: 'Tarn-et-Garonne', value: '82' },
                { text: 'Var', value: '83' },
                { text: 'Vaucluse ', value: '84' },
                { text: 'Vendée ', value: '85' },
                { text: 'Vienne ', value: '86' },
                { text: 'Haute-Vienne ', value: '87' },
                { text: 'Vosges ', value: '88' },
                { text: 'Yonne', value: '89' },
                { text: 'Territ. de Belfort ', value: '90' },
                { text: 'Essonne', value: '91' },
                { text: 'Hauts-de-Seine ', value: '92' },
                { text: 'Seine-Saint-Denis', value: '93' },
                { text: 'Val-de-Marne ', value: '94' },
                { text: 'Val-d Oise ', value: '95' },
                { text: 'DOM-TOM', value: '97' },
                { text: 'Guadeloupe ', value: '971' },
                { text: 'Martinique ', value: '972' },
                { text: 'Guyane ', value: '973' },
                { text: 'Réunion', value: '974' },
                { text: 'Saint-Pierre-et-Miq. ', value: '975' },
                { text: 'Wallis-et-Futuna ', value: '976' },
                { text: 'Hors-France', value: '99' }
              ]
            },
            {
              text: 'Status*',
              model: 'order',
              select: '1',
              option: [
                { text: 'Open', value: 'E0001' },
                { text: 'In Process', value: 'E0002' },
                { text: 'Complete', value: 'E0003' },
                { text: 'Reject', value: 'E0007' }
              ]
            },
            {
              text: 'Problem description',
              model: 'symptom',
              select: '1',
              option:
              [
                { value: '111', text: 'TV - No Power' },
                { value: '119', text: 'TV - No Switch-On From Standby' },
                { value: '11B', text: 'TV - Cyclic Power On / Off' },
                { value: '11K', text: 'TV - Set Start-Up Too Slow' },
                { value: '11X', text: 'TV - Other Power Problem' },
                { value: '151', text: 'TV - No Remote Control Operation' },
                { value: '152', text: 'TV - Incorrect Remote Control Operation' },
                { value: '153', text: 'TV - Remote Programming / Learning Problem' },
                { value: '154', text: 'TV - Poor Remote Control Sensitivity' },
                { value: '15X', text: 'TV - Other Remote Control Problem' },
                { value: '161', text: 'TV - Damage/ Deforme Cover' },
                { value: '163', text: 'TV - Button problem' },
                { value: '166', text: 'TV - Damage Plug/Port/Connector/Card Holder' },
                { value: '168', text: 'TV - Appearance problem' },
                { value: '16A1', text: 'TV - Damage Screen /Panel' },
                { value: '16A2', text: 'TV - Screen/Panel Scratch' },
                { value: '16A3', text: 'TV - Cover Gap' },
                { value: '16A4', text: 'TV - Damaged Packaging' },
                { value: '16A5', text: 'TV - Damaged Control Knob/Button/Keypad' },
                { value: '16D', text: 'TV - Tv Burning / Smoke/Fire' },
                { value: '16F', text: 'TV - Peculiar Smell' },
                { value: '16J', text: 'TV - Tv Very Hot / Parts Melting' },
                { value: '16K', text: 'TV - Screen Foreign Body' },
                { value: '16N', text: 'TV - Damaged Power Cable' },
                { value: '16S', text: 'TV - Consumer Injury' },
                { value: '17D', text: 'TV - Mistake Language / LOGO Character Set' },
                { value: '17N', text: 'TV - Menu Function Problem' },
                { value: '12A1', text: 'TV - Apply Automatic Exits' },
                { value: '12A2', text: 'TV - Application Frozen status' },
                { value: '12A3', text: 'TV - Not Switched on After OTA Upgrade' },
                { value: '12A4', text: 'TV - AbnormallyFunction After OTA Upgrade' },
                { value: '12A5', text: 'TV - OTA Download Failed' },
                { value: '12A6', text: 'TV - Application Unavailable' },
                { value: '12A7', text: 'TV - APPWorking Abnormally' },
                { value: '12A8', text: 'TV - Network Video Playback Frozen' },
                { value: '12A9', text: 'TV - APP-Youtube NotWorking' },
                { value: '12B1', text: 'TV - APP-NETFLIXNot Working' },
                { value: '12B2', text: 'TV - BrowserWorking Abnormally' },
                { value: '216', text: 'TV - No BS/CS Signal' },
                { value: '217', text: 'TV - No CS Signal' },
                { value: '218', text: 'TV - No TV Signal' },
                { value: '21A1', text: 'TV - AV/VGA/HDMI Not Operation' },
                { value: '21A2', text: 'TV - Network /WIFI Not Available' },
                { value: '21A3', text: 'TV - Channel Edit Abnoraml' },
                { value: '21A4', text: 'TV - AbnormallyRecording' },
                { value: '21A5', text: 'TV - CI/B-CAS Card Recognition Failure' },
                { value: '21A6', text: 'TV - B-CAS Card Un-Installation' },
                { value: '21A7', text: 'TV - AntennaPowerFaulty' },
                { value: '21F', text: 'TV - No Internet/Network Initialization Fail' },
                { value: '22A', text: 'TV - Poor TV Signal' },
                { value: '22C', text: 'TV - Poor/Interrupt Internet/Network connect' },
                { value: '286', text: 'TV - EPG Problem' },
                { value: '71A', text: 'TV - HDD Not Recognized / Boot Failure' },
                { value: '31A0', text: 'TV - Unstable Picture' },
                { value: '31A1', text: 'TV - No Picture Without Backlight' },
                { value: '31A2', text: 'TV - No Picture Has Backlight' },
                { value: '31A3', text: 'TV - Screen Vertical And Horizontal Tape' },
                { value: '31A4', text: 'TV - White Screen' },
                { value: '31A5', text: 'TV - Light Leakage' },
                { value: '31A6', text: 'TV - HDR Display Abnormally' },
                { value: '31A7', text: 'TV - Blurred Picture' },
                { value: '31A8', text: 'TV - Input Lag' },
                { value: '31A9', text: 'TV - Picture Interference' },
                { value: '321', text: 'TV - Picture Too Dark' },
                { value: '326', text: 'TV - Shadows On Picture' },
                { value: '345', text: 'TV - Jitter On Picture' },
                { value: '346', text: 'TV - Ghosting On Picture' },
                { value: '34C', text: 'TV - Clouding, “MURA”' },
                { value: '356', text: 'TV - Flashing Picture' },
                { value: '385', text: 'TV - Bright, Dark, Or Flashing Pixels' },
                { value: '386', text: 'TV - Lines On Screen' },
                { value: '420', text: 'TV - Colour Level Problem' },
                { value: '140', text: 'TV - AbnormallyNoise' },
                { value: '511', text: 'TV - No Audio' },
                { value: '517', text: 'TV - No Audio From Earphone / Headphone' },
                { value: '519', text: 'TV - No Audio From Digital Output' },
                { value: '51A1', text: 'TV - ARC Connection No Audio' },
                { value: '51A2', text: 'TV - AV/VGA/HDMINo Audio Output' },
                { value: '51A3', text: 'TV - Audio Delay / Lip-Sync Problem' },
                { value: '51X', text: 'TV - Other Sound problem' },
                { value: '521', text: 'TV - Low Audio Level' },
                { value: '522', text: 'TV - High Audio Level' },
                { value: '741', text: 'TV - Button/ Touch Button Not Working' },
                { value: '744', text: 'TV - Sticky / Hard To Press Key(s)' },
                { value: '74A1', text: 'TV - Key Function Disorder' },
                { value: '74A2', text: 'TV - Key Button Unsensitive' },
                { value: '81A1', text: 'TV - No Accessory' },
                { value: '81A2', text: 'TV - No Remote' },
                { value: '81A3', text: 'TV - No/CI Card /B-CAS Card' },
                { value: '81A4', text: 'TV - No Base Bracket' },
                { value: '81A5', text: 'TV - No Screw/Screw Mistake' },
                { value: '81A6', text: 'TV - No Stand/Stand Mistake' },
                { value: '81A7', text: 'TV - Remote Mistake' },
                { value: '81A8', text: 'TV - Accessory Mistake' },
                { value: '81A9', text: 'TV - Damaged Accessory' },
                { value: '81B1', text: 'TV - Damaged Base' },
                { value: '81B2', text: 'TV - No Manual' },
                { value: '81B3', text: 'TV - Other Accessory Problem' },
                { value: '81B4', text: 'TV - Base Unstable' },
                { value: 'Z0A1', text: 'TV - Customer Installation /Requirement' },
                { value: 'Z0A3', text: 'TV - Wall Mounted Bracket Unable To Install' },
                { value: 'Z0A4', text: 'TV - Base Unable To Install' },
                { value: '111', text: 'freezer - No power' },
                { value: '11A', text: 'freezer - Powers up but no operation' },
                { value: '11C', text: 'freezer - Blowing external (mains) fuse' },
                { value: '11F', text: 'freezer - Not operating' },
                { value: '11H', text: 'freezer - Internal protection switch / fuse in set' },
                { value: '124', text: 'freezer - Insufficient heating / temperature (not' },
                { value: '125', text: 'freezer - Excessive heating / temperature (not spe' },
                { value: '126', text: 'freezer - Insufficient cooling (not specific)' },
                { value: '127', text: 'freezer - Excessive cooling (not specific)' },
                { value: '12A1', text: 'freezer - Water delay' },
                { value: '12A2', text: 'freezer - water extended' },
                { value: '131', text: 'freezer - No or faulty display' },
                { value: '132', text: 'freezer - Faulty lamp / LED operation' },
                { value: '133', text: 'freezer - Faulty level meter operation' },
                { value: '134', text: 'freezer - No or faulty on-screen display operation' },
                { value: '138', text: 'freezer - Faulty alarm / error display' },
                { value: '13D', text: 'freezer - Warning light does not work' },
                { value: '13E', text: 'freezer - Warning light lights up' },
                { value: '149', text: 'freezer - Cracking' },
                { value: '14A', text: 'freezer - Whistling' },
                { value: '14B', text: 'freezer - Bubbling, boiling' },
                { value: '14F', text: 'freezer - Squealing' },
                { value: '14G', text: 'freezer - Grinding' },
                { value: '14I', text: 'freezer - Pumping noise' },
                { value: '14X', text: 'freezer - Other "abnormal noise" problem' },
                { value: '161', text: 'freezer - Damaged / deformed cabinet / panel / gla' },
                { value: '162', text: 'freezer - Damaged handle / Clip / transport strap' },
                { value: '163', text: 'freezer - Damaged control knob(s) / button(s) / ke' },
                { value: '164', text: 'freezer - Damaged door / cover' },
                { value: '165', text: 'freezer - Damaged seal' },
                { value: '16D', text: 'freezer - Set burning / emits smoke' },
                { value: '16E', text: 'freezer - External surface damage (bubbling / peel' },
                { value: '16G', text: 'freezer - Weak / damaged stand' },
                { value: '16J', text: 'freezer - Set gets very hot / parts melting' },
                { value: '16L', text: 'freezer - Burning marks' },
                { value: '16M', text: 'freezer - Internal surface damage (bubbling / peel' },
                { value: '16N', text: 'freezer - Damaged power cable' },
                { value: '16P', text: 'freezer - Damaged accessory' },
                { value: '16R', text: 'freezer - Discolouration' },
                { value: '16S', text: 'freezer - Consumer hurt' },
                { value: '16T', text: 'freezer - Damaged / defect filter' },
                { value: '171', text: 'freezer - Faulty clock function' },
                { value: '175', text: 'freezer - Programming / user adjustment problem' },
                { value: '178', text: 'freezer - Faulty memory function' },
                { value: '17F', text: 'freezer - Switch / keypad / regulator not operatin' },
                { value: '17L', text: 'freezer - Faulty operation of parental lock / keyl' },
                { value: '17O', text: 'freezer - No interior lighting' },
                { value: '17P', text: 'freezer - Faulty user control function' },
                { value: '17S', text: 'freezer - Temperature not adjustable' },
                { value: '61B', text: 'freezer - Control / switch not working' },
                { value: '651', text: 'freezer - Uneven feet' },
                { value: '653', text: 'freezer - Vibrating / jumping' },
                { value: '654', text: 'freezer - Part(s) loose' },
                { value: '655', text: 'freezer - Wheel defect' },
                { value: '693', text: 'freezer - Door does not close properly' },
                { value: '694', text: 'freezer - Door cannot be opened / heavy to open' },
                { value: '695', text: 'freezer - Damaged door gasket' },
                { value: '696', text: 'freezer - Damaged door frame' },
                { value: '697', text: 'freezer - Damaged door glass' },
                { value: '698', text: 'freezer - Door falls off' },
                { value: '699', text: 'freezer - Faulty door switch' },
                { value: '69A', text: 'freezer - Door slanted' },
                { value: '69B', text: 'freezer - Damaged hinge' },
                { value: '69C', text: 'freezer - Malfunctioning door locking device' },
                { value: 'B11', text: 'freezer - No cooling' },
                { value: 'B12', text: 'freezer - No freezing' },
                { value: 'B13', text: 'freezer - No warming up' },
                { value: 'B16', text: 'freezer - No defrosting' },
                { value: 'B17', text: 'freezer - No dehumidification' },
                { value: 'B19', text: 'freezer - Ventilator does not switch off' },
                { value: 'B1A', text: 'freezer - No ice production' },
                { value: 'B1B', text: 'freezer - No crushed ice production' },
                { value: 'B1C', text: 'freezer - No cold water production' },
                { value: 'B1X', text: 'freezer - Other no function problem' },
                { value: 'B22', text: 'freezer - Insufficient freezing' },
                { value: 'B26', text: 'freezer - Excessive freezing' },
                { value: 'B29', text: 'freezer - Insufficient ventilation power' },
                { value: 'B2A', text: 'freezer - Ventilation power only at one side' },
                { value: 'B2B', text: 'freezer - Ventilation power not adjustable' },
                { value: 'B2C', text: 'freezer - Compressor operating all the time' },
                { value: 'B2D', text: 'freezer - Insufficient filter operation' },
                { value: 'B2X', text: 'freezer - Other operational problem' },
                { value: 'B32', text: 'freezer - Rotted / damaged food' },
                { value: 'B33', text: 'freezer - Ice cream too hard' },
                { value: 'B34', text: 'freezer - Insufficient ice cube quality' },
                { value: 'B35', text: 'freezer - Condensed water on food' },
                { value: 'B3X', text: 'freezer - Other "cooling / heating poor performanc' },
                { value: 'B41', text: 'freezer - Condensation inside cabinet' },
                { value: 'B42', text: 'freezer - Ice build up' },
                { value: 'B44', text: 'freezer - Water inside cabinet' },
                { value: 'B45', text: 'freezer - Noisy compressor' },
                { value: 'B46', text: 'freezer - Noisy magnet switch' },
                { value: 'B47', text: 'freezer - Noisy thermostat' },
                { value: 'B4X', text: 'freezer - Other water / ice / noise problem' },
                { value: 'B51', text: 'freezer - Fuel, Oil leakage' },
                { value: 'B53', text: 'freezer - Smoke emission' },
                { value: 'B54', text: 'freezer - Water leakage' },
                { value: 'B61', text: 'freezer - Damaged evaporator' },
                { value: 'B62', text: 'freezer - Temperature adjustment stuck' },
                { value: 'B63', text: 'freezer - Selection switch defective' },
                { value: 'B64', text: 'freezer - Filter holder defective' },
                { value: '111', text: 'Refrigerator - No power' },
                { value: '11A', text: 'Refrigerator - Powers up but no operation' },
                { value: '11C', text: 'Refrigerator - Blowing external (mains) fuse' },
                { value: '11F', text: 'Refrigerator - Not operating' },
                { value: '11H', text: 'Refrigerator - Internal protection switch / fuse in set' },
                { value: '124', text: 'Refrigerator - Insufficient heating / temperature (not' },
                { value: '125', text: 'Refrigerator - Excessive heating / temperature (not spe' },
                { value: '126', text: 'Refrigerator - Insufficient cooling (not specific)' },
                { value: '127', text: 'Refrigerator - Excessive cooling (not specific)' },
                { value: '12A1', text: 'Refrigerator - Water delay' },
                { value: '12A2', text: 'Refrigerator - water extended' },
                { value: '131', text: 'Refrigerator - No or faulty display' },
                { value: '132', text: 'Refrigerator - Faulty lamp / LED operation' },
                { value: '133', text: 'Refrigerator - Faulty level meter operation' },
                { value: '134', text: 'Refrigerator - No or faulty on-screen display operation' },
                { value: '138', text: 'Refrigerator - Faulty alarm / error display' },
                { value: '13D', text: 'Refrigerator - Warning light does not work' },
                { value: '13E', text: 'Refrigerator - Warning light lights up' },
                { value: '149', text: 'Refrigerator - Cracking' },
                { value: '14A', text: 'Refrigerator - Whistling' },
                { value: '14B', text: 'Refrigerator - Bubbling, boiling' },
                { value: '14F', text: 'Refrigerator - Squealing' },
                { value: '14G', text: 'Refrigerator - Grinding' },
                { value: '14I', text: 'Refrigerator - Pumping noise' },
                { value: '14X', text: 'Refrigerator - Other "abnormal noise" problem' },
                { value: '161', text: 'Refrigerator - Damaged / deformed cabinet / panel / gla' },
                { value: '162', text: 'Refrigerator - Damaged handle / Clip / transport strap' },
                { value: '163', text: 'Refrigerator - Damaged control knob(s) / button(s) / ke' },
                { value: '164', text: 'Refrigerator - Damaged door / cover' },
                { value: '165', text: 'Refrigerator - Damaged seal' },
                { value: '16D', text: 'Refrigerator - Set burning / emits smoke' },
                { value: '16E', text: 'Refrigerator - External surface damage (bubbling / peel' },
                { value: '16G', text: 'Refrigerator - Weak / damaged stand' },
                { value: '16J', text: 'Refrigerator - Set gets very hot / parts melting' },
                { value: '16L', text: 'Refrigerator - Burning marks' },
                { value: '16M', text: 'Refrigerator - Internal surface damage (bubbling / peel' },
                { value: '16N', text: 'Refrigerator - Damaged power cable' },
                { value: '16P', text: 'Refrigerator - Damaged accessory' },
                { value: '16R', text: 'Refrigerator - Discolouration' },
                { value: '16S', text: 'Refrigerator - Consumer hurt' },
                { value: '16T', text: 'Refrigerator - Damaged / defect filter' },
                { value: '171', text: 'Refrigerator - Faulty clock function' },
                { value: '175', text: 'Refrigerator - Programming / user adjustment problem' },
                { value: '178', text: 'Refrigerator - Faulty memory function' },
                { value: '17F', text: 'Refrigerator - Switch / keypad / regulator not operatin' },
                { value: '17L', text: 'Refrigerator - Faulty operation of parental lock / keyl' },
                { value: '17O', text: 'Refrigerator - No interior lighting' },
                { value: '17P', text: 'Refrigerator - Faulty user control function' },
                { value: '17S', text: 'Refrigerator - Temperature not adjustable' },
                { value: '61B', text: 'Refrigerator - Control / switch not working' },
                { value: '651', text: 'Refrigerator - Uneven feet' },
                { value: '653', text: 'Refrigerator - Vibrating / jumping' },
                { value: '654', text: 'Refrigerator - Part(s) loose' },
                { value: '655', text: 'Refrigerator - Wheel defect' },
                { value: '693', text: 'Refrigerator - Door does not close properly' },
                { value: '694', text: 'Refrigerator - Door cannot be opened / heavy to open' },
                { value: '695', text: 'Refrigerator - Damaged door gasket' },
                { value: '696', text: 'Refrigerator - Damaged door frame' },
                { value: '697', text: 'Refrigerator - Damaged door glass' },
                { value: '698', text: 'Refrigerator - Door falls off' },
                { value: '699', text: 'Refrigerator - Faulty door switch' },
                { value: '69A', text: 'Refrigerator - Door slanted' },
                { value: '69B', text: 'Refrigerator - Damaged hinge' },
                { value: '69C', text: 'Refrigerator - Malfunctioning door locking device' },
                { value: 'B11', text: 'Refrigerator - No cooling' },
                { value: 'B12', text: 'Refrigerator - No freezing' },
                { value: 'B13', text: 'Refrigerator - No warming up' },
                { value: 'B16', text: 'Refrigerator - No defrosting' },
                { value: 'B17', text: 'Refrigerator - No dehumidification' },
                { value: 'B19', text: 'Refrigerator - Ventilator does not switch off' },
                { value: 'B1A', text: 'Refrigerator - No ice production' },
                { value: 'B1B', text: 'Refrigerator - No crushed ice production' },
                { value: 'B1C', text: 'Refrigerator - No cold water production' },
                { value: 'B1X', text: 'Refrigerator - Other no function problem' },
                { value: 'B22', text: 'Refrigerator - Insufficient freezing' },
                { value: 'B26', text: 'Refrigerator - Excessive freezing' },
                { value: 'B29', text: 'Refrigerator - Insufficient ventilation power' },
                { value: 'B2A', text: 'Refrigerator - Ventilation power only at one side' },
                { value: 'B2B', text: 'Refrigerator - Ventilation power not adjustable' },
                { value: 'B2C', text: 'Refrigerator - Compressor operating all the time' },
                { value: 'B2D', text: 'Refrigerator - Insufficient filter operation' },
                { value: 'B2X', text: 'Refrigerator - Other operational problem' },
                { value: 'B32', text: 'Refrigerator - Rotted / damaged food' },
                { value: 'B33', text: 'Refrigerator - Ice cream too hard' },
                { value: 'B34', text: 'Refrigerator - Insufficient ice cube quality' },
                { value: 'B35', text: 'Refrigerator - Condensed water on food' },
                { value: 'B3X', text: 'Refrigerator - Other "cooling / heating poor performanc' },
                { value: 'B41', text: 'Refrigerator - Condensation inside cabinet' },
                { value: 'B42', text: 'Refrigerator - Ice build up' },
                { value: 'B44', text: 'Refrigerator - Water inside cabinet' },
                { value: 'B45', text: 'Refrigerator - Noisy compressor' },
                { value: 'B46', text: 'Refrigerator - Noisy magnet switch' },
                { value: 'B47', text: 'Refrigerator - Noisy thermostat' },
                { value: 'B4X', text: 'Refrigerator - Other water / ice / noise problem' },
                { value: 'B51', text: 'Refrigerator - Fuel, Oil leakage' },
                { value: 'B53', text: 'Refrigerator - Smoke emission' },
                { value: 'B54', text: 'Refrigerator - Water leakage' },
                { value: 'B61', text: 'Refrigerator - Damaged evaporator' },
                { value: 'B62', text: 'Refrigerator - Temperature adjustment stuck' },
                { value: 'B63', text: 'Refrigerator - Selection switch defective' },
                { value: 'B64', text: 'Refrigerator - Filter holder defective' },
                { value: '111', text: 'Washing Machine - No power' },
                { value: '118', text: 'Washing Machine - Power-off function not working' },
                { value: '119', text: 'Washing Machine - No switch-on from standby' },
                { value: '11A', text: 'Washing Machine - Powers up but no operation' },
                { value: '11B', text: 'Washing Machine - Cyclic power on / off' },
                { value: '11C', text: 'Washing Machine - Blowing external (mains) fuse' },
                { value: '11D', text: 'Washing Machine - Set switches off by itself' },
                { value: '11F', text: 'Washing Machine - Not operating' },
                { value: '11H', text: 'Washing Machine - Internal protec switch set triggers' },
                { value: '124', text: 'Washing Machine - Insufficient heating / temperature' },
                { value: '125', text: 'Washing Machine - Excessive heating / temperature' },
                { value: '126', text: 'Washing Machine - Insufficient cooling (not specific)' },
                { value: '127', text: 'Washing Machine - Excessive cooling (not specific)' },
                { value: '131', text: 'Washing Machine - No or faulty display' },
                { value: '132', text: 'Washing Machine - Faulty lamp / LED operation' },
                { value: '133', text: 'Washing Machine - Faulty level meter operation' },
                { value: '134', text: 'Washing Machine - No or faulty on-screen display operation' },
                { value: '13D', text: 'Washing Machine - Warning light does not work' },
                { value: '13E', text: 'Washing Machine - Warning light lights up' },
                { value: '143', text: 'Washing Machine - Noisy cabinet / cracking trays' },
                { value: '145', text: 'Washing Machine - Noisy component(s)' },
                { value: '146', text: 'Washing Machine - Rattle' },
                { value: '149', text: 'Washing Machine - Cracking' },
                { value: '14A', text: 'Washing Machine - Whistling' },
                { value: '14F', text: 'Washing Machine - Squealing' },
                { value: '14G', text: 'Washing Machine - Grinding' },
                { value: '14I', text: 'Washing Machine - Pumping noise' },
                { value: '14X', text: 'Washing Machine - Other "abnormal noise" problem' },
                { value: '161', text: 'Washing Machine - Damaged / deformed cabinet / panel' },
                { value: '162', text: 'Washing Machine - Damaged handle / Clip / transport strap' },
                { value: '163', text: 'Washing Machine - Damaged control knob(s) / button(s)' },
                { value: '164', text: 'Washing Machine - Damaged door / cover' },
                { value: '165', text: 'Washing Machine - Damaged seal' },
                { value: '166', text: 'Washing Machine - Damaged plug / socket / terminal' },
                { value: '168', text: 'Washing Machine - Damaged cartridge or stylus' },
                { value: '16D', text: 'Washing Machine - Set burning / emits smoke' },
                { value: '16E', text: 'Washing Machine - External surface damage' },
                { value: '16K', text: 'Washing Machine - Foreign substance on / in unit' },
                { value: '16L', text: 'Washing Machine - Burning marks' },
                { value: '16M', text: 'Washing Machine - Internal surface damage' },
                { value: '16N', text: 'Washing Machine - Damaged power cable' },
                { value: '16P', text: 'Washing Machine - Damaged accessory' },
                { value: '16R', text: 'Washing Machine - Discolouration' },
                { value: '16T', text: 'Washing Machine - Damaged / defect filter' },
                { value: '16U', text: 'Washing Machine - Packaging' },
                { value: '171', text: 'Washing Machine - Faulty clock function' },
                { value: '173', text: 'Washing Machine - Faulty timer programming' },
                { value: '174', text: 'Washing Machine - Faulty timer operation' },
                { value: '175', text: 'Washing Machine - Programming / user adjustment problem' },
                { value: '179', text: 'Washing Machine - Faulty input switching' },
                { value: '17E', text: 'Washing Machine - Error code / signal appears in display' },
                { value: '17F', text: 'Washing Machine - Switch / keypad / not operating' },
                { value: '17L', text: 'Washing Machine - Faulty operation of parental lock' },
                { value: '17M', text: 'Washing Machine - Faulty mode switching' },
                { value: '17P', text: 'Washing Machine - Faulty user control function' },
                { value: '17S', text: 'Washing Machine - Temperature not adjustable' },
                { value: '61B', text: 'Washing Machine - Control / switch not working' },
                { value: '651', text: 'Washing Machine - Uneven feet' },
                { value: '653', text: 'Washing Machine - Vibrating / jumping' },
                { value: '654', text: 'Washing Machine - Part(s) loose' },
                { value: '655', text: 'Washing Machine - Wheel defect' },
                { value: '693', text: 'Washing Machine - Door does not close properly' },
                { value: '694', text: 'Washing Machine - Door cannot be opened / heavy to open' },
                { value: '698', text: 'Washing Machine - Door falls off' },
                { value: '699', text: 'Washing Machine - Faulty door switch' },
                { value: '69A', text: 'Washing Machine - Door slanted' },
                { value: '69B', text: 'Washing Machine - Damaged hinge' },
                { value: '69C', text: 'Washing Machine - Malfunctioning door locking device' },
                { value: '69D', text: 'Washing Machine - Noise when opening / closing door' },
                { value: 'A11', text: 'Washing Machine - No heating' },
                { value: 'A12', text: 'Washing Machine - No water draining / pumping out' },
                { value: 'A13', text: 'Washing Machine - No rinsing / no circulation' },
                { value: 'A14', text: 'Washing Machine - No drying' },
                { value: 'A15', text: 'Washing Machine - No salt consumption' },
                { value: 'A16', text: 'Washing Machine - No clear rinse / softening consumption' },
                { value: 'A17', text: 'Washing Machine - No detergent consumption' },
                { value: 'A18', text: 'Washing Machine - No water inlet' },
                { value: 'A19', text: 'Washing Machine - No air drain' },
                { value: 'A1A', text: 'Washing Machine - No water in container' },
                { value: 'A1B', text: 'Washing Machine - No spinning' },
                { value: 'A1C', text: 'Washing Machine - Stops during program flow' },
                { value: 'A1D', text: 'Washing Machine - Continues via stop' },
                { value: 'A1E', text: 'Washing Machine - Continues without stopping' },
                { value: 'A1F', text: 'Washing Machine - Program stops and pumps constantly' },
                { value: 'A1G', text: 'Washing Machine - Water inlet not stopped' },
                { value: 'A1H', text: 'Washing Machine - Heating up without water' },
                { value: 'A1J', text: 'Washing Machine - No water through flow / blockage' },
                { value: 'A1K', text: 'Washing Machine - No whitening agent consumption' },
                { value: 'A1L', text: 'Washing Machine - No softener consumption' },
                { value: 'A21', text: 'Washing Machine - Pumping out improperly' },
                { value: 'A22', text: 'Washing Machine - Insufficient water inlet' },
                { value: 'A23', text: 'Washing Machine - Insufficient drying / spinning' },
                { value: 'A24', text: 'Washing Machine - Excessive salt consumption' },
                { value: 'A25', text: 'Washing Machine - Excessive clear rinse consumption' },
                { value: 'A26', text: 'Washing Machine - Excessive detergent consumption' },
                { value: 'A27', text: 'Washing Machine - Takes excessive water' },
                { value: 'A28', text: 'Washing Machine - Program flow too fast / slow' },
                { value: 'A29', text: 'Washing Machine - Water in soft rinsing chamber' },
                { value: 'A2A', text: 'Washing Machine - Improper spinning' },
                { value: 'A2B', text: 'Washing Machine - Program knob remains in every position' },
                { value: 'A2C', text: 'Washing Machine - Takes detergent only partially' },
                { value: 'A2D', text: 'Washing Machine - Takes softening agent immediately' },
                { value: 'A2E', text: 'Washing Machine - Water enters and drains off immediately' },
                { value: 'A2G', text: 'Washing Machine - Drying time too long' },
                { value: 'A2H', text: 'Washing Machine - Wrong drum positioning' },
                { value: 'A31', text: 'Washing Machine - Not clean' },
                { value: 'A39', text: 'Washing Machine - Wrinkled laundry' },
                { value: 'A3A', text: 'Washing Machine - Burnt laundry' },
                { value: 'A3B', text: 'Washing Machine - Laundry hot and dry' },
                { value: 'A3C', text: 'Washing Machine - Laundry hot and damp' },
                { value: 'A3D', text: 'Washing Machine - Laundry damaged' },
                { value: 'A44', text: 'Washing Machine - Spinning noise' },
                { value: 'A51', text: 'Washing Machine - Water leakage' },
                { value: 'A52', text: 'Washing Machine - Steam emission' },
                { value: 'A53', text: 'Washing Machine - Foaming' },
                { value: 'A54', text: 'Washing Machine - Damaged hose' },
                { value: 'A55', text: 'Washing Machine - Air emission' },
                { value: 'A57', text: 'Washing Machine - Drum lid damaged / opened' },
                { value: 'A58', text: 'Washing Machine - Drum blocked' },
                { value: 'A62', text: 'Washing Machine - Damaged rinse aid chamber / cover' },
                { value: 'A63', text: 'Washing Machine - Damaged detergent chamber / cover' },
                { value: 'A64', text: 'Washing Machine - Damaged fluff filter' }
              ]
            },
            {
              text: 'Type de demande',
              model: 'type',
              select: '1',
              option:
              [
                { text: 'General Advice', value: 'C1' },
                { text: 'Technical Advice', value: 'C2' },
                { text: 'Online Remote Consulting', value: 'C3' }
              ]
            },
            {
              text: 'Sous-type de Demande',
              model: 'consult',
              select: '1',
              option: [
                { text: 'Information Avant-Vente', value: 'B01' },
                { text: 'Suivi d intervention', value: 'B02' },
                { text: 'Demande Marketing', value: 'B03' },
                { text: 'Demande Commerciale', value: 'B04' },
                { text: 'Demande de support', value: 'B05' },
                { text: 'ODR', value: 'B09' }
              ]
            },
            { text: 'Descript. Demande', model: 'note' }
          ]
        },
        {
          client: 'schumacher',
          fields: [
            { text: 'Modèles', model: 'modele' },
            { text: 'Envie', model: 'envie' },
            { text: 'Immatriculation', model: 'immatriculation' },
            { text: 'Code postal', model: 'zip' },
            { text: 'Concession', model: 'concession' }
          ]
        },
        {
          client: 'volvo',
          fields: [
            {
              text: 'Modèle *',
              model: 'modele',
              select: '1',
              option: [{ text: this.$t('Non précisé'), value: 'ALL MODELS' },
                { text: this.$t('V90 Cross Country'), value: 'V90 Cross Country' },
                { text: this.$t('V90'), value: 'V90' },
                { text: this.$t('V60'), value: 'V60' },
                { text: this.$t('V40 Cross Country'), value: 'V40 Cross Country' },
                { text: this.$t('V40'), value: 'V40' },
                { text: this.$t('XC40'), value: 'XC40' },
                { text: this.$t('XC90'), value: 'XC90' },
                { text: this.$t('XC60'), value: 'XC60' }]
            },
            {
              text: 'Type de demande *',
              model: 'type',
              select: '1',
              option: [{ text: this.$t('Demande d\'essai'), value: 'Test_drive_request' },
                { text: this.$t('Demande d\'offre / Autre demande'), value: 'Offer_request' }]
            },
            {
              text: 'A recontacter par *',
              model: 'contact',
              select: '1',
              option: [{ text: this.$t('Téléphone'), value: 'Phone' },
                { text: this.$t('Email'), value: 'Email' },
                { text: this.$t('SMS'), value: 'SMS' }]
            }
          ]
        },
        {
          client: 'icad',
          fields: [
            {
              text: 'Region du projet*',
              model: 'region',
              select: '1',
              option: [{ text: 'Alsace', value: '42' },
                { text: 'Aquitaine', value: '72' },
                { text: 'Auvergne', value: '83' },
                { text: 'Basse-Normandie', value: '25' },
                { text: 'Bourgogne', value: '26' },
                { text: 'Bretagne', value: '53' },
                { text: 'Centre-Val de Loire', value: '24' },
                { text: 'Champagne-Ardenne', value: '21' },
                { text: 'Corse', value: '94' },
                { text: 'Franche-Comté', value: '43' },
                { text: 'Guadeloupe', value: '01' },
                { text: 'Guyane', value: '03' },
                { text: 'Haute-Normandie', value: '23' },
                { text: 'Ile-de-France', value: '11' },
                { text: 'Languedoc-Roussillon', value: '91' },
                { text: 'La Réunion', value: '04' },
                { text: 'Limousin', value: '74' },
                { text: 'Lorraine', value: '41' },
                { text: 'Martinique', value: '02' },
                { text: 'Midi-Pyrénées', value: '73' },
                { text: 'Nord-Pas-de-Calais', value: '31' },
                { text: 'Pays de la Loire', value: '52' },
                { text: 'Picardie', value: '22' },
                { text: 'Poitou-Charentes', value: '54' },
                { text: 'Provence-Alpes-Côte d\'Azur', value: '93' },
                { text: 'Rhône-Alpes', value: '82' }]
            },
            { text: 'Numéro du programme*', model: 'programme' },
            { text: 'Habiter/Investir', model: 'acheter' },
            { text: "Code postal de l'internaute*", model: 'zip' },
            { text: 'Budget', model: 'budget' },
            { text: 'Nb de pièces', model: 'nbpieces' },
            { text: 'Département (2 chiffres, ex 75)', model: 'departement' }
          ]
        },
        {
          client: 'akerys',
          fields: [
            { text: 'Code postal', model: 'zip' },
            { text: 'Ville', model: 'ville' },
            { text: 'Téléphone fixe', model: 'telf' },
            { text: 'Téléphone mobile', model: 'telm' },
            { text: 'Imposition', model: 'impos' },
            { text: 'Propriétaire', model: 'proprio' },
            { text: 'Profession-Poste occupé', model: 'job' },
            { text: 'Situation', model: 'situation' },
            { text: "Nb d'enfants", model: 'enfant' },
            { text: 'Crédit en cours', model: 'cTotal' },
            { text: 'Epargne', model: 'epargne' },
            { text: 'Date de recontact', model: 'dateRappel' },
            { text: 'Heure de recontact', model: 'horraireRappel' },
            { text: 'Revenu', model: 'revenu' }
          ]
        },
        {
          client: 'ketb',
          fields: [
            { text: 'Code postal', model: 'zip' },
            { text: 'Ville', model: 'ville' },
            { text: 'Téléphone fixe', model: 'zip' },
            { text: 'Téléphone mobile', model: 'telf' },
            { text: 'Imposition', model: 'impos' },
            { text: 'Propriétaire', model: 'proprio' },
            { text: 'Profession-Poste occupé', model: 'job' },
            { text: 'Situation', model: 'situation' },
            { text: "Nb d'enfants", model: 'enfant' },
            { text: 'Crédit en cours', model: 'cTotal' },
            { text: 'Epargne', model: 'epargne' },
            { text: 'Date de recontact', model: 'dateRappel' },
            { text: 'Heure de recontact', model: 'horraireRappel' },
            { text: 'Revenu', model: 'revenu' }
          ]
        },
        {
          client: 'inoya',
          fields: [
            {
              text: 'Panier validé',
              model: 'panier',
              select: '1',
              option: [{ text: 'Non', value: '1' }, { text: 'Oui', value: '2' }]
            },
            {
              text: 'Type de peau',
              model: 'type',
              select: '1',
              option: [
                { text: 'MIXTE', value: 'Peau_Mixte' },
                { text: 'GRASSE', value: 'Peau_Grasse' },
                { text: 'SECHE', value: 'Peau_Seche' },
                { text: 'NORMALE', value: 'Peau_Normale' }
              ]
            },
            {
              text: 'Problématiques de peau',
              model: 'pb',
              select: '1',
              option: [
                { text: 'TACHES', value: 'Prob_Taches' },
                { text: 'BOUTONS', value: 'Prob_Boutons' },
                {
                  text: 'TEINT NON UNIFORME',
                  value: 'Prob_Teint_Non_Uniforme'
                },
                { text: 'VERGETURES', value: 'Prob_Vergetures' },
                { text: 'AUCUNE', value: 'Prob_Aucune' },
                { text: 'AUTRES', value: 'Prob_Autres' }
              ]
            },
            {
              text: 'Durée problématique',
              model: 'duree',
              select: '1',
              option: [
                { text: 'Pas de choix', value: '' },
                { text: 'Moins de 3 ans', value: '1' },
                { text: 'Plus de 3 ans', value: '2' }
              ]
            },
            {
              text: 'Suivi par un Dermatologue',
              model: 'suivi',
              select: '1',
              option: [{ text: 'Non', value: '1' }, { text: 'Oui', value: '2' }]
            },
            {
              text: 'Utilise un contraceptif',
              model: 'contrat',
              select: '1',
              option: [{ text: 'Non', value: '1' }, { text: 'Oui', value: '2' }]
            }
          ]
        }
      ],
      custom_motifs: [],
      custom_champs: []
    }
  },
  props: ['datasVisiteur'],
  watch: {
    'datasVisiteur.visiteurID': function (v) {
      if (v) {
        this.showLead()
      }
    }
  },

  methods: {
    // ----------------------------------------------------------------------------
    // affiche le lead
    // ----------------------------------------------------------------------------
    showLead () {
      this.loading = true
      let dataToGet = new window.FormData()
      dataToGet.append('session', this.datasVisiteur.visiteurID)
      dataToGet.append('siteID', this.datasVisiteur.siteID)
      dataToGet.append('specialtable', this.user.licSpecialtable)
      this.axios
        .post('get/visitor_lead.php', dataToGet, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          console.log('response', response)
          this.visiteurLead = {
            session_id: response.data.session_id || '',
            visitor_ip: response.data.visitor_ip || '',
            key: response.data.key || '',
            gender: response.data.gender || '',
            comment: response.data.comment || '',
            name: response.data.name || '',
            lname: response.data.lname || '',
            fname: response.data.fname || '',
            email: response.data.email || '',
            tel: response.data.tel || '',
            lic_eezy_lead: response.data.lic_eezy_lead || '',
            objectif_site: response.data.objectif.site || '',
            objectif_title: response.data.objectif.title || '',
            objectif_infos: response.data.objectif.infos || '',
            motif: response.data.motif || '',
            motif2: response.data.motif2 || '',
            motifs: response.data.motifs || '',
            customLabel1: response.data.customLabel1 || '',
            customLabel2: response.data.customLabel2 || '',
            customLabel3: response.data.customLabel3 || '',
            nuxe: response.data.nuxe || '',
            nuxe2: response.data.nuxe2 || '',
            orpi2: response.data.orpi2 || '',
            company: response.data.company || '',
            url: response.data.url || '',
            typebien: response.data.typebien || '',
            surface: response.data.surface || '',
            budget: response.data.budget || '',
            destination: response.data.destination || '',
            nbpieces: response.data.nbpieces || '',
            zip: response.data.zip || '',
            ville: response.data.ville || '',
            immatriculation: response.data.immatriculation || '',
            concession: response.data.concession || '',
            envie: response.data.envie || '',
            modele: response.data.modele || '',
            suite: response.data.suite || '',
            situation: response.data.situation || '',
            job: response.data.job || '',
            apport: response.data.apport || '',
            age: response.data.age || '',
            revenuf: response.data.revenuf || '',
            revenu: response.data.revenu || '',
            proprio: response.data.proprio || '',
            impos: response.data.impos || '',
            telm: response.data.telm || '',
            telf: response.data.telf || '',
            region: response.data.region || '',
            acheter: response.data.acheter || '',
            programme: response.data.programme || '',
            departement: response.data.departement || '',
            horraireRappel: response.data.horraireRappel || '',
            dateRappel: response.data.dateRappel || '',
            epargne: response.data.epargne || '',
            cTotal: response.data.cTotal || '',
            cConso: response.data.cConso || '',
            cVehic: response.data.cVehic || '',
            cAutres: response.data.cAutres || '',
            cResi: response.data.cResi || '',
            enfant: response.data.enfant || '',
            panier: response.data.panier || '',
            type: response.data.type || '',
            contact: response.data.contact || '',
            pb: response.data.pb || '',
            duree: response.data.duree || '',
            suivi: response.data.suivi || '',
            contrat: response.data.contrat || '',
            inoya: response.data.inoya || '',
            inoya2: response.data.inoya2 || '',
            inoya3: response.data.inoya3 || '',
            date_account: response.data.date_account || '',
            date_birth: response.data.date_birth || '',
            status: response.data.status || '',
            date_status: response.data.date_status || '',
            points_acquired: response.data.points_acquired || '',
            points_ongoing: response.data.points_ongoing || '',
            points_cumyear: response.data.points_cumyear || '',
            optin_email: response.data.optin_email || '',
            date_first_purch: response.data.date_first_purch || '',
            date_last_purch: response.data.date_last_purch || '',
            last_trans: response.data.last_trans || '',
            last_trans_ttc: response.data.last_trans_ttc || '',
            last_trans_ht: response.data.last_trans_ht || '',
            devise: response.data.devise || '',
            points_last_trans: response.data.points_last_trans || '',
            achat_last_trans: response.data.achat_last_trans || '',
            special_client: response.data.special_client || '',
            user: response.data.user || '',
            title: response.data.title || '',
            usage: response.data.usage || '',
            method: response.data.method || '',
            address: response.data.address || '',
            city: response.data.city || '',
            building: response.data.building || '',
            country: response.data.country || '',
            province: response.data.province || '',
            order: response.data.order || '',
            symptom: response.data.symptom || '',
            consult: response.data.consult || '',
            note: response.data.note || '',
            dateSendLead: response.data.dateSendLead || ''
          }
          // special pour easiware
          if (response.data.special_client === 'inoya') {
            this.theChat = this.chatToEasiware(this.datasVisiteur.visiteurID)
            this.initMotifInoya()
            this.default_champs = [
              { text: _.upperFirst(this.$t('gender')), value: 'gender' },
              { text: _.upperFirst(this.$t('lastName')), value: 'lname' },
              { text: _.upperFirst(this.$t('firstName')), value: 'fname' },
              { text: _.upperFirst(this.$t('comment')), value: 'comment' },
              { text: _.upperFirst(this.$t('email')), value: 'email' },
              { text: _.upperFirst(this.$t('phone')), value: 'tel' }
            ]
          }
          // special pour easiware
          if (response.data.special_client === 'nuxe') {
            this.theChat = this.chatToEasiware(this.datasVisiteur.visiteurID)
            this.initMotifNuxe()
          }
          // special pour hisense
          if (response.data.special_client === 'hisense') {
            this.default_champs = [
              { text: _.upperFirst(this.$t('lastName')) + '*', value: 'lname' },
              { text: _.upperFirst(this.$t('firstName')) + '*', value: 'fname' },
              { text: _.upperFirst(this.$t('comment')), value: 'comment' },
              { text: _.upperFirst(this.$t('email')), value: 'email' },
              { text: _.upperFirst(this.$t('phone')) + '*', value: 'tel' }
            ]
          }

          for (let n in this.$store.state._Sites.sites) {
            if (
              this.$store.state._Sites.sites[n].LIC_KEY ===
              this.visiteurLead.key
            ) {
              let customLead = this.$store.state._Sites.sites[n]
                .DSK_CUSTOM_LEAD_FORM
              if (customLead !== '') {
                for (let i = 0; i < customLead.motifs.length; ++i) {
                  let label = customLead.motifs[i]
                  if (label === 'support') {
                    label = 'Support'
                  } else if (label === 'lead') {
                    label = 'Prospect qualifié'
                  } else if (label === 'sale') {
                    label = 'Vente'
                  } else if (label === 'resa') {
                    label = 'Réservation'
                  } else if (label === 'devis') {
                    label = 'Devis'
                  } else if (label === 'contact') {
                    label = 'Contact'
                  }
                  this.custom_motifs.push({
                    text: label,
                    value: customLead.motifs[i]
                  })
                }
                for (let i = 0; i < customLead.info.length; ++i) {
                  let label = customLead.info[i]
                  if (label === 'gender') {
                    label = this.$t('gender')
                  } else if (label === 'lname') {
                    label = this.$t('lastName')
                  } else if (label === 'fname') {
                    label = this.$t('firstName')
                  } else if (label === 'comment') {
                    label = this.$t('comment')
                  } else if (label === 'email') {
                    label = 'Email'
                  } else if (label === 'tel') {
                    label = this.$t('phone')
                  } else if (label === 'company') {
                    label = this.$t('company')
                  } else if (label === 'url') {
                    label = this.$t('url')
                  }
                  this.custom_champs.push({
                    text: label,
                    value: customLead.info[i]
                  })
                }
                if (this.custom_motifs.length !== 0) {
                  this.default_motif = this.custom_motifs
                } else {
                  this.default_motif = []
                }
                if (this.custom_champs.length !== 0) {
                  this.default_champs = this.custom_champs
                  for (let i = 0; i < this.custom_champs.length; ++i) {
                    let j = this.custom_champs[i].value
                    this.visiteurLead[j] = response.data[j]
                  }
                } else {
                  this.default_champs = []
                }
              }
            }
          }

          // sauve l'action de modification du motif (pour orpi et ses clotures de chat)
          if (
            this.visiteurLead.motif !== undefined &&
            this.visiteurLead.motif !== ''
          ) {
            // sauve l'action de modification du motif (pour orpi et ses clotures de chat)
            let tempVis = _.cloneDeep(this.datasVisiteur)
            tempVis.motif = true
            this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', tempVis)
          }
          this.error = false
        })
        .catch(() => {
          this.error = true
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('error'),
            context: 'error'
          })
        })
        .then(() => {
          this.loading = false
          this.dateSendLead = this.visiteurLead.dateSendLead
        })
    },

    // Si il y a un changement dans le formulaire
    // alors on debloque le bouton d'envois de lead
    changeForm () {
      console.log('changement form')
      this.leadSend = false
      this.smsSend = false
      this.leadSend2 = false
    },
    /**
     *  Valide le formulaire et update la BDD et le fichier XML pour le front
     */
    submit (data) {
      // if (data.dateSendLead) {
      console.log('submit', data)
      // }
      // let dateSendLead = data.dateSendLead ? data.dateSendLead : 0
      this.loadingSaveLead = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      dataToPost.append('specialtable', this.user.licSpecialtable)
      dataToPost.append('chat', this.theChat)
      dataToPost.append('dateSendLead', data.dateSendLead ? data.dateSendLead : '')
      this.axios
        .post('put/visitor_lead.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Lead Enregistré',
            context: 'success'
          })
          // sauve l'action de modification du motif (pour orpi et ses clotures de chat)
          let tempVis = _.cloneDeep(this.datasVisiteur)
          tempVis.motif = true
          this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', tempVis)
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: "Echec de l'enregistrement",
            context: 'error'
          })
        })
        .then(_ => { this.loadingSaveLead = false })
    },
    clear () {
      this.$refs.form.reset()
    },
    sendSms () {
      this.loadingSms = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      this.theChat = this.chatToEasiware(this.datasVisiteur.visiteurID)
      this.axios
        .post('post/lead_sms.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          // le lead est texté
          this.smsSend = true
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'SMS envoyé',
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'SMS NON envoyé',
            context: 'error'
          })
          this.txtLead = 'Probleme d\'envois du SMS'
        })
        .then(_ => { this.loadingSms = false })
    },
    sendlead () {
      this.loadingLead = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      this.theChat = this.chatToEasiware(this.datasVisiteur.visiteurID)
      dataToPost.append('chat', this.theChat)
      this.axios
        .post('post/lead_mail.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          // le lead est enregistré
          this.submit(
            {
              'dateSendLead': Date.now()
            }
          )
          this.leadSend = true
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Lead envoyé',
            context: 'success'
          })
          this.dateSendLead = Date.now()
          // this.txtLead = 'Lead envoyé'
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Lead NON envoyé',
            context: 'error'
          })
          this.txtLead = 'Probleme d\'envois du lead'
        })
        .then(_ => { this.loadingLead = false })
    },
    inoyaEasiware (ouverture) {
      if (ouverture === 'S1') {
        this.loadingLead = true
      } else {
        this.loadingLead2 = true
      }
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      dataToPost.append('ouverture', ouverture)
      dataToPost.append('chat', this.theChat)
      this.axios
        .post('post/inoya_easiware.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          // le lead est enregistré
          this.submit(
            {
              'dateSendLead': Date.now()
            }
          )
          if (ouverture === 'S1') {
            this.leadSend = true
          } else {
            this.leadSend2 = true
          }
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Lead envoyé',
            context: 'success'
          })
          this.dateSendLead = Date.now()
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Lead NON envoyé',
            context: 'error'
          })
          this.txtLead = 'Probleme d\'envois du lead'
        })
        .then(_ => {
          if (ouverture === 'S1') {
            this.loadingLead = false
          } else {
            this.loadingLead2 = false
          }
        })
    },
    sisleySelligent () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      dataToPost.append('chat', this.theChat)
      this.axios
        .post('post/sisley_selligent.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Lead send',
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Lead NOT send',
            context: 'error'
          })
        })
        .then(_ => {})
    },
    sisleyGetSelligent () {
      this.loadingLead = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      this.axios
        .post('post/sisley_get_selligent.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          // le lead est enregistré
          this.submit(
            {
              'dateSendLead': Date.now()
            }
          )
          this.leadSend = true
          this.dateSendLead = Date.now()
          this.visiteurLead.gender = response.data.gender || ''
          this.visiteurLead.lname = response.data.lname || ''
          this.visiteurLead.fname = response.data.fname || ''
          this.visiteurLead.date_account = response.data.date_account || ''
          this.visiteurLead.date_birth = response.data.date_birth || ''
          this.visiteurLead.status = response.data.status || ''
          this.visiteurLead.date_status = response.data.date_status || ''
          this.visiteurLead.points_acquired = response.data.points_acquired || ''
          this.visiteurLead.points_ongoing = response.data.points_ongoing || ''
          this.visiteurLead.points_cumyear = response.data.points_cumyear || ''
          this.visiteurLead.optin_email = response.data.optin_email || ''
          this.visiteurLead.date_first_purch = response.data.date_first_purch || ''
          this.visiteurLead.date_last_purch = response.data.date_last_purch || ''
          this.visiteurLead.last_trans = response.data.last_trans || ''
          this.visiteurLead.last_trans_ttc = response.data.last_trans_ttc || ''
          this.visiteurLead.last_trans_ht = response.data.last_trans_ht || ''
          this.visiteurLead.devise = response.data.devise || ''
          this.visiteurLead.points_last_trans = response.data.points_last_trans || ''
          this.visiteurLead.achat_last_trans = response.data.achat_last_trans || ''
          this.visiteurLead.tel = response.data.tel || ''
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Email found, information updated',
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Email NOT found',
            context: 'error'
          })
          this.txtLead = 'Probleme d\'envois du lead'
        })
        .then(_ => { this.loadingLead = false })
    },
    updateSubMotifNuxe () {
      this.loadingLead = true
      this.nuxe_motif_sub = ''
      if (this.visiteurLead.nuxe === '2') {
        this.nuxe_motif_sub = this.nuxe_motif2a
      } else if (this.visiteurLead.nuxe === '31') {
        this.nuxe_motif_sub = this.nuxe_motif31a
      } else if (this.visiteurLead.nuxe === '6') {
        this.nuxe_motif_sub = this.nuxe_motif6a
      } else if (this.visiteurLead.nuxe === '7') {
        this.nuxe_motif_sub = this.nuxe_motif7a
      } else if (this.visiteurLead.nuxe === '8') {
        this.nuxe_motif_sub = this.nuxe_motif8a
      } else if (this.visiteurLead.nuxe === '172') {
        this.nuxe_motif_sub = this.nuxe_motif172a
      }
    },
    initMotifNuxe () {
      if (this.visiteurLead.nuxe === '2') {
        this.nuxe_motif_sub = this.nuxe_motif2a
      } else if (this.visiteurLead.nuxe === '31') {
        this.nuxe_motif_sub = this.nuxe_motif31a
      } else if (this.visiteurLead.nuxe === '6') {
        this.nuxe_motif_sub = this.nuxe_motif6a
      } else if (this.visiteurLead.nuxe === '7') {
        this.nuxe_motif_sub = this.nuxe_motif7a
      } else if (this.visiteurLead.nuxe === '8') {
        this.nuxe_motif_sub = this.nuxe_motif8a
      } else if (this.visiteurLead.nuxe === '172') {
        this.nuxe_motif_sub = this.nuxe_motif172a
      }
    },
    updateSubMotifInoya () {
      this.visiteurLead.inoya2 = ''
      if (this.visiteurLead.inoya === '1') {
        this.inoya_motif2 = this.inoya_motif2a
      } else if (this.visiteurLead.inoya === '2') {
        this.inoya_motif2 = this.inoya_motif2b
      } else if (this.visiteurLead.inoya === '3') {
        this.inoya_motif2 = []
      } else if (this.visiteurLead.inoya === '4') {
        this.inoya_motif2 = this.inoya_motif2c
      } else if (this.visiteurLead.inoya === '5') {
        this.inoya_motif2 = this.inoya_motif2d
      } else if (this.visiteurLead.inoya === '6') {
        this.inoya_motif2 = this.inoya_motif2e
      } else if (this.visiteurLead.inoya === '7') {
        this.inoya_motif2 = []
      }
      if (this.visiteurLead.inoya !== '2') {
        this.inoya_motif2bb = []
        this.visiteurLead.inoya3 = ''
      }
    },
    updateSubSubMotifInoya () {
      if (this.visiteurLead.inoya2 === '777') {
        this.inoya_motif2bb = this.inoya_motif3
      } else {
        this.inoya_motif2bb = []
        this.visiteurLead.inoya3 = ''
      }
    },
    initMotifInoya () {
      if (this.visiteurLead.inoya === '1') {
        this.inoya_motif2 = this.inoya_motif2a
      } else if (this.visiteurLead.inoya === '2') {
        this.inoya_motif2 = this.inoya_motif2b
      } else if (this.visiteurLead.inoya === '3') {
        this.inoya_motif2 = []
      } else if (this.visiteurLead.inoya === '4') {
        this.inoya_motif2 = this.inoya_motif2c
      } else if (this.visiteurLead.inoya === '5') {
        this.inoya_motif2 = this.inoya_motif2d
      } else if (this.visiteurLead.inoya === '6') {
        this.inoya_motif2 = this.inoya_motif2e
      } else if (this.visiteurLead.inoya === '7') {
        this.inoya_motif2 = []
      }
      if (this.visiteurLead.inoya !== '2') {
        this.inoya_motif2bb = []
        this.visiteurLead.inoya3 = ''
      }
      if (this.visiteurLead.inoya2 === '777') {
        this.inoya_motif2bb = this.inoya_motif3
      } else {
        this.inoya_motif2bb = []
        this.visiteurLead.inoya3 = ''
      }
    },
    chatToEasiware (sesId) {
      var conversExport = ''
      if (document.querySelector('#conversation_' + sesId)) {
        var listDiv = document.querySelectorAll(
          '#conversation_' + sesId + ' div'
        )
        for (var i = 0; i < listDiv.length; i++) {
          var date = ''
          var author = ''
          var msg = ''
          var bulleChat = listDiv[i]
          if (
            bulleChat.className !== 'WatchBox-conversation' &&
            bulleChat.className !== 'bulle_Agent_BO' &&
            bulleChat.className !== 'bulle_Visiteur_BO' &&
            bulleChat.className !== 'bulle_BO'
          ) {
            if (bulleChat.querySelector('.timestamp_Visiteur_BO')) {
              date = bulleChat.querySelector('.timestamp_Visiteur_BO').textContent
            } else if (bulleChat.querySelector('.timestamp_Agent_BO')) {
              date = bulleChat.querySelector('.timestamp_Agent_BO').textContent
            }
            if (bulleChat.querySelector('.nom_Visiteur_BO')) {
              author = bulleChat.querySelector('.nom_Visiteur_BO').textContent
              if (
                this.visiteurLead.fname !== '' &&
                this.visiteurLead.fname !== 'undefined'
              ) {
                author = this.visiteurLead.fname
              }
              if (
                this.visiteurLead.lname !== '' &&
                this.visiteurLead.lname !== 'undefined'
              ) {
                author += ' ' + this.visiteurLead.lname
              }
            } else if (bulleChat.querySelector('.nom_Agent_BO')) {
              author = bulleChat.querySelector('.nom_Agent_BO').textContent
            }
            if (bulleChat.querySelector('.message_Visiteur')) {
              msg = bulleChat.querySelector('.message_Visiteur').textContent
            } else if (bulleChat.querySelector('.message_Agent')) {
              msg = bulleChat.querySelector('.message_Agent').textContent
            }
            if (date !== '' || author !== '' || msg !== '') {
              conversExport += date + ' - ' + author + ': ' + msg + '<br>'
            }
          }
        }
      }
      if (conversExport !== '') {
        conversExport = conversExport.replace(/'/g, ' ')
        conversExport = conversExport.replace(/\+/g, ' ')
        conversExport = conversExport.replace(/&amp;/g, ' ')
        conversExport = conversExport.replace(/&/g, ' ')
        conversExport = conversExport.replace(/<p class="sysMessage ">/g, '')
      }
      return conversExport
    },
    hisenseSAP () {
      this.loadingLead = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      this.axios
        .post('post/hisense-sap.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          // le lead est enregistré
          this.submit(
            {
              'dateSendLead': Date.now()
            }
          )
          this.leadSend = true
          this.dateSendLead = Date.now()
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Successfully send to SAP',
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Error from SAP',
            context: 'error'
          })
          this.txtLead = 'Probleme d\'envois du lead'
        })
        .then(_ => { this.loadingLead = false })
    },
    zendesk () {
      this.loadingLeadZendesk = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      this.axios
        .post('post/lead_zendesk.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Ticket envoyé vers Zendesk',
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Ticket NON envoyé',
            context: 'error'
          })
        })
        .then(_ => { this.loadingLeadZendesk = false })
    },
    salesforce () {
      this.loadingLeadSelesForce = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('lead', JSON.stringify(this.visiteurLead))
      this.axios
        .post('post/lead_salesforce.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Piste envoyé vers Salesforce',
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Piste NON crée',
            context: 'error'
          })
        })
        .then(_ => { this.loadingLeadSelesForce = false })
    }
    /* ga () {
        alert('Google Analytics')
      } */
  },

  mounted () {
    this.showLead()
  },

  computed: {
    ...mapGetters('_User', ['user']),

    // retourne la date du dernier envois de l'autoinvitation avec moment
    leadSendDate () {
      if (this.dateSendLead) {
        return 'Lead envoyé le ' + moment(this.dateSendLead).format('LLLL')
      } else {
        return null
      }
    }
  }
}
</script>

<style>
.wz_cardLead {
  height: 100% !important;
}
.wz_loading {
  top: calc(50% - 35px);
  position: relative;
}
.ficheLeadVisiteur {
  background-color: #fff;
  padding-top: 8px;
  padding-bottom: 8px;
}
.formLeadVisiteur {
  background-color: #fff;
  margin: 0px 26px 8px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzFicheLeadVisiteur.vue